import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import TSelect from '../common/TSelect'
import TButton from '../common/TButton'
import { jsonResponseHandler } from '../../utils/FetchHelper';
import TInputForm from "../common/TInputForm";
import {connect} from "react-redux";
import {addPrefix} from "../../utils/UriUtil";
import {TISTORY} from "../../constants/Service"

@connect(state => ({}), dispatch => ({
  dispatch
}))
class CategorySettingForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      optionList : props.optionList,
      initialSelected : props.selected,
      selected: props.selected,
      changed : {},
      newMarkDaysLayer : props.selected.newMark === 1
    };
  }

  @autobind
  changeSelection(property, value) {
    const { selected, changed }= this.state;
    let diff = {};
    diff[property] = value;

    this.checkLayerToggle(property, value);

    this.setState({
      selected : Object.assign({}, selected, diff),
      changed : Object.assign({}, changed, diff),
    });
  }

  @autobind
  checkLayerToggle(property, value) {
    if (property === 'newMark') {
      this.setState({
        newMarkDaysLayer: value === 1
      })
    }
  }

  @autobind
  labelLengthChange(labelLengthOnTree) {
    const { selected, changed }= this.state;

    if (labelLengthOnTree > 40){
      labelLengthOnTree = 40;
    }

    const change = { labelLengthOnTree : labelLengthOnTree};

    this.setState({
      selected : Object.assign({}, selected, change),
      changed : Object.assign({}, changed, change),
    })
  }

  @autobind
  handleSave(callback, failCallback){
    const { dispatch } = this.props;
    let { selected, changed } = this.state;
    changed['newMarkDays'] = selected['newMarkDays'];
    changed['newMark'] = selected['newMark'];

    fetch(addPrefix("/manage/category/setting.json"),
      {
        method: 'put',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(this.state.changed)
      })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        callback();
        this.setState({
          initialSelected : Object.assign({}, this.state.selected, data.data),
          selected : Object.assign({}, this.state.selected, data.data),
          changed : {},
        });
      })
      .catch(e => {
        console.log(e);
        failCallback();
      });
  }

  render() {
    const { optionList, initialSelected, selected, newMarkDaysLayer } = this.state

    return (
      <form className="wrap_set">
        <fieldset>
          <legend className="screen_out">카테고리 설정</legend>
          {window.Config.service === TISTORY &&
            <div className="item_set">
              카테고리명이
              <TInputForm type="text" className="tf_set tf_set1" value={selected.labelLengthOnTree} onChange={this.labelLengthChange} />
              글자까지 표시됩니다.
            </div>
          }
          <div className="item_set">
            카테고리별 글 수를
            <TSelect defaultClassName={'opt_set opt_cate2'} selectItem={this.changeSelection} propertyName={"showValueOnTree"} selected={selected} optionList={optionList} />
          </div>
          <div className="item_set">
            카테고리에 새 글 발행 여부를
            <TSelect defaultClassName={'opt_set opt_cate3'} selectItem={this.changeSelection} propertyName={"newMark"} selected={selected} optionList={optionList} />
          </div>
          {newMarkDaysLayer &&
            <div className="item_set item_sub">
              <TSelect defaultClassName={'opt_set opt_cate4'} selectItem={this.changeSelection} propertyName={"newMarkDays"} selected={selected} optionList={optionList} />
              이내에 발행된 글이 있으면 새 글 여부를 표시합니다.
            </div>
          }

        </fieldset>
        <fieldset>
          <legend className="screen_out">저장 버튼</legend>
          <TButton onClick={this.handleSave} initialValues={initialSelected} currentValues={selected}/>
        </fieldset>
      </form>
    )
  }
}

export default CategorySettingForm
